/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mFirendShareOrReward.vue?vue&type=template&id=619f2242"
import script from "./mFirendShareOrReward.vue?vue&type=script&lang=js"
export * from "./mFirendShareOrReward.vue?vue&type=script&lang=js"
import style0 from "./mFirendShareOrReward.vue?vue&type=style&index=0&id=619f2242&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports